import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import {createPinia} from "pinia";
import "@/styles/global.css";
import {apiStore} from "./stores/api";
import {crossbarStore} from "./stores/crossbar";
import {measurementStore} from "./stores/measurement";
import {socketStore} from "./stores/socket";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import {registerSW} from "virtual:pwa-register";

const updateSW = registerSW({
    onNeedRefresh() {
        console.log("new version detected, reload service worker");
        updateSW();
    },

    onOfflineReady() {
        console.log("onOfflineReady");
    }
});

//locales
import {messages} from "./locales/messages";
import {createI18n} from "vue-i18n";
import localforage from "localforage";

(async () => {
    const app = createApp(App);
    const pinia = createPinia();
    app.use(pinia);

    // stores
    const api = apiStore();
    await api.init(window.env.BASE_URL, window.env.CLIENT_ID, window.env.CLIENT_SECRET);

    const socket = socketStore();
    socket.init(window.env.SOCKET_HOST, window.env.SOCKET_PORT);

    const crossbar = crossbarStore();
    crossbar.init(window.env.CROSSBAR);

    const measurement = measurementStore();
    measurement.init();

    // create the stores before the router
    app.use(router);

    // Bugsnag
    if (window.env.BUGSNAG) {
        Bugsnag.start({
            apiKey: window.env.BUGSNAG,
            plugins: [new BugsnagPluginVue()]
        });
        const bugsnagVue = Bugsnag.getPlugin("vue");
        app.use(bugsnagVue);
    } else {
        console.log("Bugsnag not started");
    }

    let cachedLocale = await localforage.getItem("locale");
    const i18n = createI18n({
        locale: cachedLocale !== null ? cachedLocale : "benl",
        messages
    });

    app.use(i18n);
    app.mount("#app");
})();
